document.addEventListener('DOMContentLoaded', function() {
    const headerElements = document.querySelectorAll('.footer-block.footer-block--menu h2');

    headerElements.forEach(function(element) {
        element.addEventListener('click', function() {
            // 画面幅が749px以下の場合のみ処理を実行
            if (window.innerWidth <= 749) {
                const nextUl = this.nextElementSibling;

                if (nextUl && nextUl.tagName.toLowerCase() === 'ul') {
                    // CSSトランジションを使用したスライド効果
                    if (nextUl.style.maxHeight === '0px' || nextUl.style.maxHeight === '') {
                        nextUl.style.maxHeight = nextUl.scrollHeight + 'px';
                        nextUl.style.opacity = '1';
                    } else {
                        nextUl.style.maxHeight = '0px';
                        nextUl.style.opacity = '0';
                    }
                }

                this.classList.toggle('open');
            }
        });
    });

    // ウィンドウサイズ変更時にスタイルをリセット（オプション）
    window.addEventListener('resize', function() {
        if (window.innerWidth > 749) {
            // 大きい画面になった時はスタイルをリセット
            const ulElements = document.querySelectorAll('.footer-block.footer-block--menu ul');
            const headerElements = document.querySelectorAll('.footer-block.footer-block--menu h2');

            ulElements.forEach(function(ul) {
                ul.style.maxHeight = '';
                ul.style.opacity = '';
            });

            headerElements.forEach(function(header) {
                header.classList.remove('open');
            });
        }
    });
});
